<template>
  <validation-provider
    class="sm:col-span-2"
    tag="div"
    name="appointment_notes"
    mode="passive"
    v-slot="{ errors }"
  >
    <form-label for="appointment_notes">Comments or special request</form-label>
    <form-textarea
      id="appointment_notes"
      v-model="internalValue"
      @input="onInput"
    ></form-textarea>
    <form-alert-msg v-if="errors[0]">{{ errors[0] }}</form-alert-msg>
  </validation-provider>
</template>

<script>
import { FormTextarea, FormLabel, FormAlertMsg } from "@/components/Form/";
import { ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationProvider,
    FormTextarea,
    FormLabel,
    FormAlertMsg,
  },
  props: ["value"],
  data() {
    return {
      internalValue: "",
    };
  },
  watch: {
    value: {
      handler(val) {
        this.internalValue = val;
      },
      immediate: true,
    },
  },
  methods: {
    onInput(val) {
      this.$emit("input:field", val);
    },
  },
};
</script>
